import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fixed',
    standalone: false
})
export class FixedPipe implements PipeTransform {
    public transform(value: any, decimalPlaces?: number): any {
        decimalPlaces = decimalPlaces || 2;
        if (isNaN(value) || value === 0) {
            return '';
        }

        return Number(value).toFixed(decimalPlaces);
    }
}
